import { useEffect, useState } from "react";
import { BASE_URL, TypeValueChain } from "../helpers/constants";
import useApiRequest from "../helpers/api_request";
import { selectAccessToken } from "../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { AxiosError } from "axios";
import { showToastMessage } from "../features/generalSlice";
import { toast } from "react-toastify";

const useValueChains = () => {
  const [loadingValueChains, setLoadingValueChains] = useState(false);
  const accessToken = useAppSelector(selectAccessToken);
  const [valueChains, setValueChains] = useState<TypeValueChain[] | []>([]);
  const apiRequest = useApiRequest();
  const dispatch = useAppDispatch();

  const getValueChains = async () => {
    setLoadingValueChains(true);
    await apiRequest({
      method: "get",
      url: BASE_URL + "/api/value-chain",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setLoadingValueChains(false);
        setValueChains(response.data);
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setLoadingValueChains(false);
      });
  };

  return {
    loadingValueChains,
    valueChains,
    getValueChains,
  };
};

export default useValueChains;
